import React from 'react'
import PropTypes from 'prop-types'
import { Title } from 'react-head'
import ContentArea from '../../components/ContentArea'
import DefaultLayout from '../../components/DefaultLayout'
import Footer from '../../components/Footer/Footer'
import Spinner from '../../components/Spinner/Spinner'
import SubPageHeader from '../../components/SubPageHeader'
import { runQuery, getDatoLocale } from '../../dato'
import { setSessionItem } from '../../storeManager'
import ErrorPage from '../ErrorPage'
import convert from 'htmr'
import withSSR from '../../components/withSSR/withSSR'
import { FormattedDate } from 'react-intl'
import { query } from './healthConsentQuery'
import { unlocalizePathname } from '../../utils/localizeLink'
import { getSlugLanguage } from '../../locale/localizationHelper'

const transforms = {
  // eslint-disable-next-line react/prop-types
  ol: function LowerLatinList({ children }) {
    return <ol className="lower-latin">{children}</ol>
  },
  // eslint-disable-next-line react/prop-types
  table: function CustomTable({ children }) {
    return (
      <table
        className={`
      type-small relative 
      mx-0 border-collapse 
      transform border-1 border-Border 
      bg-transparent shadow-none xl:left-1/2 xl:-translate-x-1/2
    `}
      >
        {children}
      </table>
    )
  },
  // eslint-disable-next-line react/prop-types
  th: function CustomTableHeading({ children }) {
    return (
      <th className="type-small border-1 border-Border px-8 py-4 normal-case tracking-normal text-Type">
        {children}
      </th>
    )
  },
  // eslint-disable-next-line react/prop-types
  td: function CustomTableCell({ children }) {
    return (
      <td className="border-1 border-Border px-8 py-6 align-top">{children}</td>
    )
  },
}

function HealthConsentDato({ data, isLoading, error }) {
  if (isLoading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center">
        <Spinner width="50" color="green" />
      </div>
    )
  }
  if (error) {
    console.error('HealthConsentDato error:', error)
    return <ErrorPage error={error} />
  }
  if (!data) {
    console.log('HealthConsentDato: No data returned')
    return (
      <ErrorPage error="No health consent data found. Please create an entry in DatoCMS with the slug 'health-consent'" />
    )
  }

  setSessionItem('bannerShown', true)

  return (
    <DefaultLayout>
      <Title>Health Consent - Lifesum</Title>
      <SubPageHeader
        heading={data.title}
        language={false}
        stickyHeader={false}
      />
      <ContentArea>
        <div className="s-text">
          {convert(data.content, { transform: transforms })}
        </div>
        <small className="type-small text-TypeSub">
          Last update: {<FormattedDate value={data.publishedAt} />}
        </small>
      </ContentArea>
      <Footer />
    </DefaultLayout>
  )
}

HealthConsentDato.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
}

HealthConsentDato.getInitialProps = ({ location, language, isPreview }) => {
  const slug = unlocalizePathname(location.pathname).replace(/^\//, '')
  const pathnameLanguage = getSlugLanguage(location.pathname)
  const requestedLanguage = pathnameLanguage || language
  const locale = getDatoLocale(requestedLanguage)

  return runQuery(query, { slug, locale }, isPreview).then(
    ({ healthConsent, fallback }) => {
      // Use the localized version if available, otherwise fall back to English
      return healthConsent || fallback
    },
  )
}

export default withSSR(HealthConsentDato)
